<template>
  <div>
    <swiper :options="swiperOption" ref="swiper" class="swiper">
      <swiper-slide v-for="g in games" :key="g.id">
        <v-img
          :contain="g.contain"
          :height="g.height"
          :width="g.width"
          :src="g.src"
        />
      </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from "vue-awesome-swiper";
  import SwiperCore, { Mousewheel, Pagination } from "swiper";

  import "swiper/components/pagination/pagination.min.css";
  import "swiper/swiper-bundle.min.css";

  SwiperCore.use([Mousewheel, Pagination]);

  export default {
    name: 'FeatureGames',
    props: {
      games: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      Swiper,
      SwiperSlide,
    },
    data() {
      return {
        swiperOption: {
          centeredSlides: false,
          direction: "horizontal",
          grabCursor: true,
          mousewheel: false,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 40
            },
            480: {
              slidesPerView: 3,
              spaceBetween: 60
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 40
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 60
            }
          }
        },
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>